<div class="dialog-header">
  <h1 mat-dialog-title>
    {{ 'Aggiungi media come allegato' | translate }}
  </h1>

  <h2>
    {{ 'Aggiungi nuovo media' | translate }}
  </h2>

  <app-media-input
    [disabled]="isUploading"
    [label]="isUploading ? 'Caricamento in corso' : 'Carica media'"
    (load)="uploadHandler($event)">
  </app-media-input>

  <h2>
    {{ 'Seleziona dalla galleria' | translate }}
  </h2>
  <ui-filters
    [dialogFilters]="MobileFiltersComponent"
    [showFiltersTitle]="false"
    (action)="applyFilterWithDelayHandler($event)">
    <app-media-filters #desktopFilter></app-media-filters>
  </ui-filters>
</div>

<ng-container *ngIf="media$ | async as media; else loading">
  <div class="dialog-content">
    <mat-dialog-content>
      <div
        class="media-container"
        *ngIf="!isLoading; else loading">
      <div
        *ngFor="let m of media.data"
        class="media"
        [title]="m.name"
        [class.selected]="isMediaSelected(m)"
        [class.range-selected]="isMediaInRangeSelection(m)"
        (click)="onMediaClick($event, m)">
        <img loading="lazy" [src]="m?.previewUrl">
        <span
          class="media-name"
          *ngIf="m.ext === 'pdf'">
          {{ m.name }}
        </span>
      </div>
      </div>
    </mat-dialog-content>
    <div class="pagination-controls">
      <div class="page-jump">
        <label for="pageSelector">{{ 'Vai a pagina' | translate }}:</label>
        <mat-form-field appearance="outline" class="page-selector">
          <mat-select
            id="pageSelector"
            [value]="currentPageIndex"
            (selectionChange)="jumpToPage($event.value)">
            <mat-option *ngFor="let pageNum of pageNumbers" [value]="pageNum - 1">
              {{ pageNum }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span class="page-info">{{ 'di' | translate }} {{ totalPages }}</span>
      </div>
      <mat-paginator
        [length]="media?.count"
        [pageSize]="media?.params?.limit"
        [pageSizeOptions]="pageSizeOptions"
        (page)="changePageHandler($event)">
      </mat-paginator>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class="media-loading-container">
    <ngx-spinner
      [fullScreen]="false"
      name="loadingMedia"
      type="square-loader"
      size="medium"
      class="loading-spinner">
    </ngx-spinner>
  </div>
</ng-template>

<div class="dialog-footer">
  <mat-dialog-actions class="media-actions">
    <div>
      <button
        mat-button
        mat-raised-button
        type="button"
        (click)="closeHandler()">
        {{ 'Annulla' | translate }}
      </button>
      <button
        mat-button
        mat-raised-button
        color="primary"
        type="button"
        (click)="saveHandler()">
        {{ 'Aggiungi' | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
